import PropTypes from 'prop-types'

const fillArrayfromOne = (n) => Array(n).fill().map((_, i) => i + 1)
const bootstrapBreakpoints = PropTypes.oneOf([...fillArrayfromOne(12), true, false, 'auto'])

export const defaultResponsiveBreakpoints = {
  lg: false,
  md: false,
  sm: false,
  xs: false,
  xl: false,
}

const responsiveBreakPoints = {
  lg: bootstrapBreakpoints,
  md: bootstrapBreakpoints,
  sm: bootstrapBreakpoints,
  xl: bootstrapBreakpoints,
  xs: bootstrapBreakpoints,
}

export default { ...responsiveBreakPoints }
